/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(["ol"], function(ol){
	var ZoomLevelIndicator = function(opt_options) {
		var options = opt_options || {};

		this.indicator = document.createElement('div');
		this.indicator.className = 'indicator';
		
		var wrapper = document.createElement('div');
		wrapper.className = 'wrapper';
		wrapper.textContent = "Zoom";
		wrapper.appendChild(this.indicator);
		
		var container = document.createElement('div');
		container.className = 'zoom-level-indicator ol-unselectable ol-control';
		container.title = "Zoom Level";
		container.appendChild(wrapper);
		
		ol.control.Control.call(this, {
			element : container,
			target : options.target,
			render : ZoomLevelIndicator.prototype.render
		});

	};
	//ol.inherits(ZoomLevelIndicator, ol.control.Control);
	ZoomLevelIndicator.prototype = Object.create(ol.control.Control.prototype);
	ZoomLevelIndicator.prototype.constructor = ZoomLevelIndicator;
	
	/**
	 * Update the ZoomLevelIndicator element.
	 * @param {ol.MapEvent} mapEvent Map event.
	 */
	ZoomLevelIndicator.prototype.render = function(mapEvent) {
		var zoom = mapEvent.map.getView().getZoom();
		this.indicator.textContent = zoom;
	};

	return ZoomLevelIndicator;
});
